import type { DocMigration } from "../docMigration";
import { migrateModelToExtendDocEntityBase } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_62: DocMigration = {
  maxSchemaVersion: "0.0.62",
  description: "Refactor Facade to implement DocEntityBase",
  apply(json: any) {
    if (json.facades) {
      migrateModelToExtendDocEntityBase(json, "facades");
    }
    return json;
  },
};

export default migration_0_0_62;
